import { AxiosResponseHeaders } from 'axios';
import { useCoreStore } from 'src/stores/core/store';
import { APP_SIGN_IN_PENDING } from 'src/shared/constants';
import { getAccountSignInUrl, shouldDeferAutherisBrowserRedirect } from '../utils/autheris-browser';

const SIGNIN_REDIRECT_GUARD = 'gptconcierge_signin_redirect';
const FORBIDDEN_TOAST_GUARD = 'gptconcierge_forbidden_toast';

if (typeof window !== 'undefined') {
  window.addEventListener('load', () => {
    try {
      sessionStorage.removeItem(SIGNIN_REDIRECT_GUARD);
      sessionStorage.removeItem(FORBIDDEN_TOAST_GUARD);
    } catch {
      /* ignore */
    }
  });
}

export default () => {
  const store = useCoreStore();

  const forceBrowserRedirect = (url: string): Promise<never> => {
    try {
      window.location.href = url;
      setTimeout(() => window.location.replace(url), 50);
    } catch {
      window.location.assign(url);
    }
    return Promise.reject(APP_SIGN_IN_PENDING);
  };

  const handleError = async (error: any) => {
    const index = store.pendingRequests.findIndex((x) => x === error.config.baseURL + error.config.url);
    if (index > -1) store.pendingRequests.splice(index, 1);

    if (error && error.response && error.response.status === 401) {
      if (!shouldDeferAutherisBrowserRedirect()) {
        try {
          if (!sessionStorage.getItem(SIGNIN_REDIRECT_GUARD)) {
            sessionStorage.setItem(SIGNIN_REDIRECT_GUARD, '1');
            return forceBrowserRedirect(getAccountSignInUrl());
          }
        } catch {
          return forceBrowserRedirect(getAccountSignInUrl());
        }
      }
      return Promise.reject(APP_SIGN_IN_PENDING);
    }

    if (
      error &&
      error.response &&
      (error.response.status === 409 || error.response.status === 422)
    ) {
      return error.response;
    } else if (error && error.response && error.response.status === 403) {
      try {
        if (!sessionStorage.getItem(FORBIDDEN_TOAST_GUARD)) {
          sessionStorage.setItem(FORBIDDEN_TOAST_GUARD, '1');
          setTimeout(() => { try { sessionStorage.removeItem(FORBIDDEN_TOAST_GUARD); } catch { /* ignore */ } }, 2000);
          store.setToastMessage({
            title: 'core.unauthorizedActionTitle',
            message: 'core.unauthorizedActionMsg',
            severity: 'error',
            translate: true
          });
        }
      } catch {
        store.setToastMessage({
          title: 'core.unauthorizedActionTitle',
          message: 'core.unauthorizedActionMsg',
          severity: 'error',
          translate: true
        });
      }
      return Promise.reject(APP_SIGN_IN_PENDING);
    } else {
      return Promise.reject(error);
    }
  };

  return {
    handleError
  };
}; 
